"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Check = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var Check = function Check() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(-1)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M11.633,19.5H1.5V.5H17.967V13.167Z",
        transform: "translate(0)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M9.5,16.157V10.5h5.657",
        transform: "translate(2.81 3.343)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x2: "9.76",
        transform: "translate(4.5 6.098)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x2: "9.76",
        transform: "translate(4.5 9.457)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x2: "3",
        transform: "translate(4.951 12.816)"
      })]
    })
  });
};
exports.Check = Check;